<template>
  <div style="margin: 10px 40px 0px">
    <el-form style="margin-right: 30px" :model="editUserForm" :rules="editUserRules" ref="editUserForm" label-width="100px" class="demo-ruleForm">
      <el-row>
        <el-col :span="12">
          <el-form-item label="工号" prop="jobnum">
            <el-input v-model="editUserForm.jobnum" placeholder="请输入工号"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="人员名称" prop="name">
            <el-input v-model="editUserForm.name" placeholder="请输入人员名称"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="联系方式" prop="phone">
            <el-input type="number" v-model="editUserForm.phone" placeholder="请输入联系方式"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="所属组织" prop="orgid">
            <el-cascader v-fixZoom
              style="width: 100%"
              :options="orgOptions"
              v-model="editUserForm.orgid"
              :filterable="true"
              placeholder="请选择所属组织"
              :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'child', emitPath: false}"
              ref="orgOptions">
            </el-cascader>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="地址" prop="address">
        <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入地址"
          v-model="editUserForm.address"
          @blur="testAddress()">
        </el-input>
      </el-form-item>
      <el-form-item label="小程序账号" prop="">
        <el-radio-group v-model="editUserForm.is_open_applet">
          <el-radio :label="0">不开通</el-radio>
          <el-radio :label="1">开通</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div>
      <el-row style="margin: 0 100px">
        <el-col :span="12">
          <div class="cancel-btn" @click="closeEdit()">
            <span>取消</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn" @click="submitAddOrg('editUserForm')">
            <span>确定</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <div style="height: 20px"></div>
  </div>
</template>

<script>
import {updateorgperson} from '../../../api/orguser'

export default {
  name: 'userEdit',
  model: {
    prop: 'editShow',
    event: 'change'
  },
  props: {
    userEditRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      orgOptions: [],
      editUserForm: {
        id: '',
        name: '',
        phone: '',
        address: '',
        jobnum: '',
        orgid: '',
        is_open_applet: 0
      },
      editUserRules: {
        jobnum: [
          { required: true, message: '请输入人员工号', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入人员名称', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' }
        ],
        orgid: [
          { required: true, message: '请选择所属组织', trigger: 'change' }
        ],
        address: [
          { required: true, message: '请输入地址', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.getEidtForm()
    this.orgOptions = this.userEditRow.orgTree
  },
  mounted () {
  },
  methods: {
    getEidtForm () {
      this.editUserForm.id = this.userEditRow.row.id
      this.editUserForm.name = this.userEditRow.row.name
      this.editUserForm.phone = this.userEditRow.row.phone
      this.editUserForm.address = this.userEditRow.row.address
      this.editUserForm.jobnum = this.userEditRow.row.jobnum
      this.editUserForm.orgid = this.userEditRow.row.orgid
      this.editUserForm.is_open_applet = this.userEditRow.row.is_open_applet
    },
    testAddress () {
      this.editUserForm.address = this.editUserForm.address.replace(/[\r\n]/g, '')
    },
    submitAddOrg (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          updateorgperson(this.editUserForm).then(res => {
            this.$notify({
              title: '成功',
              message: '成功更新平台人员',
              type: 'success',
              duration: 2000
            })
            this.golobleObject.updateTableUser()
            this.$emit('change', false)
          }).catch(() => {
            this.$notify.error({
              title: '失败',
              message: '更新平台人员失败'
            })
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    closeEdit () {
      this.$emit('change', false)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/userEdit.vue